import React from "react";
import { Modal } from "reactstrap";
import QRCode from "qrcode.react";
import "./twoFa.scss";

type ModalEnableTwoFactorProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  link: string;
};
const ModalEnableTwoFactor = ({
  isOpen,
  toggle,
  link,
}: ModalEnableTwoFactorProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: 30 }}>
      <div className="two-factor__header">
        <span className="two-factor__header__title">
          Sử dụng ứng dụng two factor authenticate để scan mã code này
        </span>
      </div>
      <div className="two-factor__body">
        <QRCode value={link} size={300} />
      </div>
      <div className="two-factor__footer">
        <div className="two-factor__confirm-button" onClick={() => toggle()}>
          <span>Xong</span>
        </div>
      </div>
    </Modal>
  );
};

export default ModalEnableTwoFactor;
